import { Autocomplete, Divider, Stack, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

import { useAllOrganizations } from "@/hooks/use-all-organizations";

function OrganizationFilter() {
  const { organizations, isLoading, error } = useAllOrganizations();

  if (isLoading || error || !organizations.length) return null;

  const organizationOptions = organizations.map((org) => ({
    label: org.name,
    slug: org.slug,
  }));
  return (
    <>
      <Typography variant="body2" letterSpacing={2} fontWeight={600}>
        Organization
      </Typography>
      <Divider />
      <Stack direction="row" sx={{ flexWrap: "wrap" }} p={1} gap={1}>
        <Controller
          name="organizationSlug"
          render={({ field: { onChange, value, ref } }) => (
            <Autocomplete
              value={organizationOptions.filter((org) => value?.includes(org.slug)) || []}
              onChange={(_, newValue) => onChange(newValue.map((org) => org.slug))}
              fullWidth
              multiple
              options={organizationOptions}
              disablePortal
              isOptionEqualToValue={(option, value) => option.slug === value.slug}
              getOptionLabel={(option) => option.label}
              getOptionDisabled={(option) => value?.includes(option.slug)}
              renderInput={(params) => (
                <TextField {...params} label="Organization" size="small" fullWidth inputRef={ref} />
              )}
            />
          )}
        />
      </Stack>
    </>
  );
}

export default OrganizationFilter;
